<template>
  <div id="app">
    <Menu />
    <router-view></router-view>
  </div>
</template>

<script>
import Menu from '@/components/menu.vue'
export default {
  components: {
    Menu
  }
}
</script>

<style lang="less">
body {
  margin: 0px;
  // background: url('./assets/banner5.png') repeat 100% 100%;
  // background-size:100% 100%
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
